import { CommonModule, Location } from '@angular/common';
import { HttpClient} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-documentos-cargados',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './documentos-cargados.component.html',
  styleUrl: './documentos-cargados.component.css',
})
export class DocumentosCargadosComponent implements OnInit {
  documents: any[] = [];
  nombre: string = '';
  filteredDocuments: any[] = [];
  searchText: string = '';
  currentPage: number = 1;
  pageSize: number = 5;
  totalPages: number = 1;
  idDocumento: string | null = null;
  selectedStatus: string = '';
  selectedDateOrder: string = '';
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.idDocumento = params['id_documento'] || null;
      if (this.idDocumento) {
        this.http.get(environment.apiUrl + `/documento/${this.idDocumento}`)
          .subscribe((res: any) => this.nombre = res.nombre);
      }
      this.fetchDocuments();
    });
  }

  fetchDocuments(): void {
    let apiUrl = environment.apiUrl + '/documento-cargado';

    // Agregar parámetros de consulta
    const queryParams: any = {};
    //console.log(queryParams)
    if (this.idDocumento) {
      queryParams.id_documento = this.idDocumento;
    }
    if (this.selectedStatus) {
      queryParams.by_status = this.selectedStatus;
    }
    if (this.selectedDateOrder) {
      queryParams.by_date = this.selectedDateOrder;
    }
    //console.log(queryParams)
    //console.log(apiUrl)
    this.http.get<any[]>(apiUrl,{params: queryParams}).subscribe(
      (data) => {
        //console.log(data);
        this.documents = data;
        this.filteredDocuments = data;
        this.updatePagination();
      },
      (error) => {
        console.error('Error al obtener documentos cargados:', error);
      }
    );
  }

  applyFilter(): void {
    this.filteredDocuments = this.documents.filter((doc) =>
      doc.institucionEducativa.cen_edu.toLowerCase().includes(this.searchText.toLowerCase())
    );


    // Resetear página actual cuando se aplica un filtro
    this.currentPage = 1;
    this.updatePagination();
  }

  updatePagination(): void {
    this.totalPages = Math.ceil(this.filteredDocuments.length / this.pageSize);
  }

  getPaginatedDocuments(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.filteredDocuments.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.updatePagination();
  }

  goBack(): void {
    this.router.navigate(['/documentos']);

  }

  goToReviewDocument(doc: any): void {
    this.router.navigate(['/documento-cargado'], {
      queryParams: { id_documento_cargado: doc.id_documento_cargado, id_documento: this.idDocumento },
    });
  }

  canReviewDocument(doc: any): boolean {
    return doc.estado !== 'LOGRADO';
  }

  downloadExcel(): void {
    const dataForExcel = this.filteredDocuments.map((doc) => ({
      ID_DOCUMENTO_CARGADO: doc.id_documento_cargado,
      DIRECTOR: doc.institucionEducativa?.director || 'N/A',
      CODIGO_MODULAR: doc.institucionEducativa.cod_mod,
      INSTITUCION: doc.institucionEducativa?.cen_edu || 'N/A',
      NIVEL_EDUCATIVO: doc.institucionEducativa?.d_niv_mod || 'N/A',
      ESTADO_REVISION: doc.estado,
      FECHA_ENTREGA: doc.fecha_subida,
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook: XLSX.WorkBook = { Sheets: { 'Documentos': worksheet }, SheetNames: ['Documentos'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const formattedFileName = this.formatFileName(this.nombre);
    this.saveAsExcelFile(excelBuffer, formattedFileName);
  }

  // Método para guardar el archivo Excel
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const url: string = window.URL.createObjectURL(data);
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = url;
    link.download = `${fileName}_${new Date().toLocaleDateString()}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
    link.remove();
  }

  private formatFileName(name: string): string {
    // Reemplaza espacios por "_" y elimina caracteres no deseados
    return name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
  }
}
